module.exports = __webpack_public_path__ + "static/assets/55c1b3687521318ec710907ff62b57f5.png";